import { render, staticRenderFns } from "./ProductionForm.vue?vue&type=template&id=20220538&"
import script from "./ProductionForm.vue?vue&type=script&lang=js&"
export * from "./ProductionForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports